import React, { useState } from "react";

/** Shows the fault's hourly cost rate and lets admins override it. */
export function FaultRateCard({ fault, isAdmin, busy, onSaveRate }) {
  const [rate, setRate] = useState(fault.cost_rate ?? 0);
  const [editing, setEditing] = useState(false);

  return (
    <div className="rounded-md bg-[#F3F8F7] p-4" data-testid="fault-rate-card">
      <div className="k-sublabel">Cost per hour</div>
      {editing ? (
        <div className="mt-1 flex items-center gap-1.5">
          <input
            type="number"
            min="0"
            step="0.01"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            data-testid="fault-rate-input"
            className="k-input !py-1 !px-2 !w-20 text-sm"
          />
          <button
            onClick={() => onSaveRate(Number(rate))}
            disabled={busy}
            data-testid="fault-rate-save"
            className="k-btn !py-1 !px-2 !text-[10px]"
          >
            Save
          </button>
          <button onClick={() => setEditing(false)} className="text-[10px] text-[#6B7280] hover:text-[#212121]">
            Cancel
          </button>
        </div>
      ) : (
        <>
          <div className="mt-1 text-lg font-heading font-semibold text-[#212121]" data-testid="fault-rate-value">
            {fault.cost_rate ? `$${fault.cost_rate}` : "—"}
          </div>
          <div className="mt-0.5 flex items-center gap-2">
            <span className="text-[10px] text-[#9CA3AF]">
              {fault.cost_source === "portal" ? "your rate" : "from the feed"}
            </span>
            {isAdmin && (
              <button
                onClick={() => { setRate(fault.cost_rate ?? 0); setEditing(true); }}
                data-testid="fault-rate-edit"
                className="text-[10px] font-heading font-semibold text-[#156F5B] hover:underline"
              >
                Set rate
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
